import { Link } from 'react-router-dom';

import styles from './styles.module.css';

const Options = () => {
    return (
        <div className={styles.wrapper}>
            {/* ID 2.B   */}
            <Link to={'/legal-structures'} className={styles.box}>
                <img src={'./images/thumb-structure.png'} alt={''} />
                <span className={styles.button}>Legal structures</span>
                <p>Optimal structures for your investments needs</p>
            </Link>

            {/* ID 2.A   */}
            <Link to={'/deal-taxes'} className={styles.box}>
                <img src={'./images/thumb-taxes.png'} alt={''} />
                <span className={styles.button}>Deal taxes</span>
                <p>Get a comprehensive tax assessment</p>
            </Link>

            <Link to={'/tax-optimisation'} className={styles.box}>
                <img src={'./images/optimisation.png'} alt={''} />
                <span className={styles.button}>Tax optimisation</span>
                <p>Get optimal investment way</p>
            </Link>

            <Link to={'/storage'} className={styles.box}>
                <img src={'./images/thumb-storage.png'} alt={''} />
                <span className={styles.button}>Storage & compliance</span>
                <p>Store your structure and ensure ongoing compliance</p>
            </Link>

            {/* ID 2.C   */}
            <Link to={'/workflows'} className={styles.box}>
                <img src={'./images/thumb-workflows.png'} alt={''} />
                <span className={styles.button}>Workflows</span>
                <p>Streamline your tasks with workflows</p>
            </Link>
        </div>
    );
};

export default Options;
